export default __webpack_public_path__ + "static/media/background-landing.1517ae81.png";